import { SVGAttributes } from 'react';

import styled from '@emotion/styled';

import { IconProps } from './icon';

export const Svg = styled.svg`
  display: inherit;
  vertical-align: top;
`;

export const IconBase = ({ ...props }: IconProps & { paths: SVGAttributes<SVGPathElement>[] }) => {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox={props.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {props.paths.map((path) => (
        <path
          key={path.d}
          d={path.d}
          fillRule={path.fillRule}
          clipRule={path.clipRule}
          fill={path.fill || props.fill}
        />
      ))}
    </Svg>
  );
};

export default IconBase;
